// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T21:06:06.805Z
// Property: Elmonica Court (ID: 6767906449166891)
// Collections: 19 amenities, 4 floorplans (live), 24 photos, 42 POIs, 1 reviews, 3 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166891",
  "property_external_id": "495800",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/elmonica-court-beaverton-or/cnlzjgg/",
  "property_google_business_url": "https://www.google.com/maps/place/Elmonica+Court+Apartments/data=!4m2!3m1!1s0x0:0x820b2c2bf07fae88?sa=X&ved=2ahUKEwiJ2ePLirySAxVN1TQHHXECCWoQ_BJ6BAgMEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495799 p0505467",
  "property_status": null,
  "property_slug": "elmonica-court",
  "property_name": "Elmonica Court",
  "property_website_url": "https://www.beavertonoregonapartments.net/",
  "property_domain": "https://www.beavertonoregonapartments.net/",
  "property_address": "1248 Southwest Kiley Way",
  "property_full_address": "1248 SW Kiley Way, Beaverton, OR 97006",
  "property_address_1": "1248 Southwest Kiley Way",
  "property_address_2": null,
  "property_address_city": "Beaverton",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97006",
  "property_address_country": "US",
  "property_address_county": "Washington County",
  "property_neighborhood_address": "Five Oaks",
  "property_address_latitude": "45.5118668",
  "property_address_longitude": "-122.8471843",
  "property_email": "elmonicacourt@ctlmanagement.com",
  "property_phone": "(503) 616-2048",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Elmonica Court in Beaverton, OR, where comfort meets convenience. Our thoughtfully designed one, two, and three-bedroom apartments boast modern amenities like a shimmering swimming pool, energy-efficient appliances, and spacious walk-in closets. Embrace a vibrant lifestyle with easy access to nature trails and nearby public transport. Secure your spot today!",
  "property_long_description": "Elmonica Court is a charming community where comfort, leisure, and entertainment are designed with your lifestyle in mind. With a prime location and top-tier amenities, our pet-friendly Beaverton apartments have everything you need to feel right at home.Whether you choose a one-, two-, or three-bedroom apartment, you'll benefit from a host of convenient features and services that will make your day a breeze. These include energy efficient appliances, large patios or balconies with attached storage, a full-sized washer and dryer unit, and on-site management and maintenance teams ready to assist you. When you're ready to step out for some relaxation and recreation, come and enjoy our community amenities, including our community adjacent walking trails, seasonal swimming pool, and resident activity program. With the TriMet Elmonica MAX Park & Ride located just outside the community, residents enjoy convenient access throughout the Portland metro area.Managed by CTL Management, Inc.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
    "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
    "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
    "width": 2048,
    "height": 956
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "144",
  "property_year_built": "1997",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.13888888888889",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Application Fee: $50 per individual or guarantor; $75 for corporate applicants.\nSecurity Deposit: $400 (refundable).\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $25 | Deposit $400",
  "property_online_leasing_url": "https://beavertonoregonapartments.securecafe.com/onlineleasing/elmonica-court/guestlogin",
  "property_resident_portal_url": "https://beavertonoregonapartments.securecafenet.com/residentservices/elmonica-court/userlogin",
  "property_apply_now_url": "https://beavertonoregonapartments.securecafe.com/onlineleasing/elmonica-court/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d73d3-04fe-771c-adad-06fcea97daa6.webp",
  "property_primary_logo_media": {
    "alt_text": "Elmonica Court Apartments logo",
    "public_id": "019d73d3-04fe-771c-adad-06fcea97daa6",
    "storage_key": "property/6767906449166891/019d73d3-04fe-771c-adad-06fcea97daa6.webp",
    "width": 744,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d73d3-0534-727f-abaa-4a845abf2631.webp",
  "property_secondary_logo_media": {
    "alt_text": "Elmonica Court Apartments logo",
    "public_id": "019d73d3-0534-727f-abaa-4a845abf2631",
    "storage_key": "property/6767906449166891/019d73d3-0534-727f-abaa-4a845abf2631.webp",
    "width": 742,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019de0b2-a502-717d-b894-ee796bf71bc4.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Generic placeholder image with a white rectangle on a dark gray background.",
    "public_id": "019de0b2-a502-717d-b894-ee796bf71bc4",
    "storage_key": "property/6767906449166891/019de0b2-a502-717d-b894-ee796bf71bc4.webp",
    "width": 744,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019de0b2-986d-711b-b7e9-5af95f7b6bff.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black rectangle",
    "public_id": "019de0b2-986d-711b-b7e9-5af95f7b6bff",
    "storage_key": "property/6767906449166891/019de0b2-986d-711b-b7e9-5af95f7b6bff.webp",
    "width": 744,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "720 - 1110",
  "property_sqft_min": "720",
  "property_sqft_max": "1110",
  "property_price_range": "1405 - 2895",
  "property_price_min": "1405",
  "property_price_max": "2895",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/elmonicacourtapartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJT-ZHyOMOlVQRiK5_8CssC4I",
  "property_youtube_url": "https://www.youtube.com/watch?t=338&v=Fw5PAnInXeM",
  "property_yelp_url": "https://www.yelp.com/biz/elmonica-court-apartments-beaverton",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Elmonica Court",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Elmonica Court in Beaverton, OR, where modern living meets nature's tranquility. Enjoy spacious floor plans with vaulted ceilings and walk-in closets, paired with amenities like a refreshing pool, scenic walking trails, and convenient online services. Experience smoke-free comfort, high-speed internet, and your personal balcony oasis today!",
  "property_home_floorplans_blurb": "Welcome to Elmonica Court in vibrant Beaverton, OR, where modern living meets comfort. With a variety of thoughtfully designed floor plans, our community offers the ideal blend of style and convenience. Browse our available apartment homes today and uncover the perfect space tailored just for you!",
  "property_home_gallery_blurb": "At Elmonica Court in vibrant Beaverton, OR, enjoy expansive floor plans with energy-efficient appliances and spacious patios. With a seasonal pool, community trails, and a resident activity program, your new home invites both relaxation and adventure. Picture yourself living here, where comfort and convenience await!",
  "property_home_neighborhood_blurb": "Welcome to Elmonica Court, where urban convenience meets educational excellence in Beaverton, OR. Nestled near Oregon Health & Science University and Pacific University, our community offers easy access to top schools like Aloha High and Five Oaks Middle. See what's around and uncover local gems right outside your doorstep!",
  "property_home_reviews_blurb": "At Elmonica Court in Beaverton, OR, residents rave about their experience, noting the \"welcoming community and friendly neighbors.\" With beautifully designed apartments and an array of amenities, our vibrant lifestyle is cherished by all. Ready to join in? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Elmonica Court in Beaverton, OR, vibrant local stops are just steps away. Immerse yourself in nature at Tualatin Hills Nature Park or enjoy a day of fun at Play Street Museum. With convenient access to Nike World Headquarters and Portland Community College, your perfect blend of work and leisure awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Elmonica Court in Beaverton, OR, your ideal home awaits. Enjoy modern living with energy-efficient appliances, vaulted ceilings, and spacious walk-in closets. Unwind by the swimming pool, soak in tranquil views, or take advantage of our self-service package lockers and online conveniences—making everyday life a breeze. Come see what sets us apart!",
  "property_applynow_blurb": "At Elmonica Court in Beaverton, OR, your ideal home awaits! Choose from stylish one, two, or three-bedroom floor plans complemented by modern amenities like a refreshing pool, covered parking, and convenient self-service package lockers. Enjoy nature trails and seamless access to the Elmonica MAX station. Apply online today!",
  "property_contactus_blurb": "At Elmonica Court in Beaverton, OR, our thoughtfully designed floor plans cater to every lifestyle, featuring one, two, and three-bedroom options. Whether you seek a cozy retreat or spacious living, we have the perfect home for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Elmonica Court in Beaverton, OR, our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—cater to every lifestyle. Have questions? Our FAQs page is your gateway to insights about community living, amenities, and more. Uncover everything you need to make Elmonica Court your next home!",
  "property_floorplans_blurb": "At Elmonica Court in Beaverton, OR, our thoughtfully designed floor plans cater to every lifestyle, offering inviting one, two, and three-bedroom options. Embrace modern living with spacious layouts that inspire comfort. Browse our available apartment homes and find the perfect fit for your unique needs today!",
  "property_gallery_blurb": "Welcome to Elmonica Court in Beaverton, OR, where modern living meets nature's tranquility. Picture yourself enjoying spacious floor plans with vaulted ceilings and walk-in closets. Unwind by the pool or explore nearby THPRD trails. With amenities like self-service package lockers and online conveniences, your perfect home awaits! ",
  "property_interactivemap_blurb": "At Elmonica Court in Beaverton, OR, vibrant living awaits! Choose from one, two, or three-bedroom apartments featuring modern amenities like spacious walk-in closets, energy-efficient appliances, and beautiful patios. With stunning nature trails nearby and convenient access to the Elmonica MAX Station, your ideal home is just a click away on our interactive map!",
  "property_pets_blurb": "Embrace life at Elmonica Court in Beaverton, OR, where your furry friends are cherished! We warmly welcome indoor adult cats and dogs under 25 lbs, ensuring a cozy home for you and your pets. Enjoy nearby parks and community amenities that make every day feel like an adventure.",
  "property_referafriend_blurb": "At Elmonica Court in Beaverton, OR, we offer a variety of spacious floor plans, including one, two, and three-bedroom apartments designed for comfort and style. Great friends make great neighbors—refer a friend to our vibrant community today and elevate your living experience together!",
  "property_residentaccess_blurb": "At Elmonica Court in Beaverton, OR, your perfect home awaits! From cozy one-bedroom retreats to spacious three-bedroom layouts, each floor plan is designed with comfort in mind. Access your resident portal seamlessly to pay rent, schedule maintenance, and enjoy community living at its best!",
  "property_reviews_blurb": "At Elmonica Court in Beaverton, OR, residents rave about the vibrant community atmosphere, with one stating, “The neighbors feel like family!” Join a welcoming environment where comfort meets convenience. See what our residents have to say about living at our community and feel the warmth that's waiting for you!",
  "property_created_at": "1762784840817",
  "property_scheduletour_blurb": "At Elmonica Court in Beaverton, OR, our thoughtfully designed floor plans—featuring one, two, and three-bedroom options—cater to your lifestyle. Interested in experiencing our vibrant community? Schedule a tour today and see what our residents cherish about calling Elmonica Court home! Your perfect space awaits.",
  "property_thankyou_blurb": "Thank you for your interest in Elmonica Court, where stylish living meets comfort in Beaverton, OR. From cozy one-bedroom retreats to spacious three-bedroom homes, our diverse floor plans cater to every lifestyle. Stay tuned—our team will connect soon to help you find your perfect fit!",
  "property_virtualtours_blurb": "Experience life at Elmonica Court in vibrant Beaverton, OR, where comfort meets style. Our thoughtfully designed one, two, and three-bedroom apartments offer the perfect retreat. Immerse yourself in our community with a virtual tour and envision your ideal living space today! Your new home awaits.",
  "property_copyright": "2026 All Rights Reserved. Elmonica Court",
  "property_seo_title_home": "Elmonica Court |  Apartments in Beaverton, OR",
  "property_seo_description_home": "Discover modern living at Elmonica Court, Beaverton, OR—spacious apartments, pool, nature trails, and easy access to the MAX station!",
  "property_seo_title_floorplans": "Floor Plans | Beaverton, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Elmonica Court in Beaverton, OR! Choose from one, two, or three-bedroom floor plans tailored for comfort and style. Browse today!",
  "property_seo_title_amenities": "Amenities | Beaverton, OR Apartments for Rent",
  "property_seo_description_amenities": "Experience the charm of Elmonica Court in Beaverton, OR! Enjoy luxury amenities, spacious floor plans, and nature just steps away. Your oasis awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Beaverton, OR",
  "property_seo_description_gallery": "Picture your life at Elmonica Court in Beaverton! Enjoy modern amenities, lush nature trails, and convenient access to public transit. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Elmonica Court Apartments",
  "property_seo_description_virtualtours": "Experience Elmonica Court in Beaverton, OR! Take a virtual tour to see our stylish one, two, and three-bedroom apartments ready for you to call home.",
  "property_seo_title_interactivemap": "Interactive Map | Elmonica Court Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Elmonica Court in Beaverton! Explore one to three-bedroom apartments with excellent amenities and nature trails.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Beaverton, OR",
  "property_seo_description_neighborhood": "Uncover the charm of Beaverton at Elmonica Court! Dive into local favorites, parks, and shops just around the corner—where your next adventure awaits!",
  "property_seo_title_contact": "Contact Us | Elmonica Court",
  "property_seo_description_contact": "Connect with Elmonica Court in Beaverton, OR! Choose from stylish 1, 2, and 3-bedroom apartments. Questions? Our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Beaverton, OR",
  "property_seo_description_faqs": "Unlock the answers to your questions about Elmonica Court in Beaverton! From floor plans to amenities, our FAQs cover all you need to know for your new home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Beaverton, OR",
  "property_seo_description_reviews": "Explore Elmonica Court in Beaverton, OR! Enjoy resident reviews, nature trails, and premium amenities. Join our vibrant community today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Beaverton, OR",
  "property_seo_description_applynow": "Find your perfect home at Elmonica Court in Beaverton, OR! Enjoy spacious floor plans, modern amenities, and nature trails just steps away. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Elmonica Court",
  "property_seo_description_residentaccess": "Elevate your living at Elmonica Court in Beaverton, OR. Access your resident portal to manage rent, schedule maintenance, and embrace hassle-free living!",
  "property_seo_title_referafriend": "Refer A Friend | Elmonica Court",
  "property_seo_description_referafriend": "Great friends make the best neighbors! Refer a friend to Elmonica Court in Beaverton, OR, and enjoy vibrant living together in our welcoming community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Elmonica Court",
  "property_seo_description_scheduletour": "Experience the charm of Elmonica Court in Beaverton, OR! Schedule your tour today and envision your new life in our welcoming apartment community.",
  "property_seo_title_privacy": "Privacy Policy | Elmonica Court",
  "property_seo_description_privacy": "Safeguard your peace of mind at Elmonica Court in Beaverton, OR. Dive into our privacy policy to learn how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Elmonica Court",
  "property_seo_description_accessibility": "Experience true inclusivity at Elmonica Court in Beaverton, OR. Our accessibility statement reflects our commitment to ensuring everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Elmonica Court",
  "property_seo_description_sitemap": "Navigate your way through Elmonica Court in Beaverton, OR. Check out our sitemap for all the details on your future home and community amenities!",
  "property_seo_title_thankyou": "Thank You | Elmonica Court",
  "property_seo_description_thankyou": "Thank you for reaching out to Elmonica Court in Beaverton! Our team is excited to connect with you soon about your future home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Beaverton, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874850215",
  "amenities": [
    {
      "id": "ec_151139bd9a2db78c6c2a020d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428858",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-7b83-702f-be1f-2fac9e7cbde9.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding trees.",
        "public_id": "019d496f-7b83-702f-be1f-2fac9e7cbde9",
        "storage_key": "property/6767906449166891/019d496f-7b83-702f-be1f-2fac9e7cbde9.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Elmonica Court seasonal swimming pool, Beaverton, OR, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e13b44b7db6607309d264d52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428850",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-3e23-73d9-bc43-9b26926bfe77.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with covered parking and lush trees.",
        "public_id": "019d496f-3e23-73d9-bc43-9b26926bfe77",
        "storage_key": "property/6767906449166891/019d496f-3e23-73d9-bc43-9b26926bfe77.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Elmonica Court building exterior and parking lot, Beaverton, OR, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05057cd22ba72e6b91c154df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428854",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-7352-77a4-b8cc-a1da060800a2.webp",
      "amenity_image_media": {
        "alt_text": "Multiple garage doors in a row, with apartment buildings in the background.",
        "public_id": "019d496f-7352-77a4-b8cc-a1da060800a2",
        "storage_key": "property/6767906449166891/019d496f-7352-77a4-b8cc-a1da060800a2.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Elmonica Court garages, Beaverton, OR, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fdcaa36806d212728a8e0bb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "86457314",
      "title": "Self Service Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-82eb-749a-8c04-f862993a9252.webp",
      "amenity_image_media": {
        "alt_text": "Elmonica Court package lockers",
        "public_id": "019d496f-82eb-749a-8c04-f862993a9252",
        "storage_key": "property/6767906449166891/019d496f-82eb-749a-8c04-f862993a9252.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Elmonica Court self service package lockers, Beaverton, OR, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_566e7b24d994ca2ed2d2b956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428846",
      "title": "Across The Street From The Elmonica Max Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-2572-707c-b7b5-09005ff02054.webp",
      "amenity_image_media": {
        "alt_text": "A modern light rail train with 'AIRPORT' displayed on its front.",
        "public_id": "019d08ac-2572-707c-b7b5-09005ff02054",
        "storage_key": "property/6767906449166891/019d08ac-2572-707c-b7b5-09005ff02054.webp",
        "width": 1317,
        "height": 814
      },
      "amenity_image_alt_text": "Trimet Max Red Line to Airport",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b09d6166fa377325f03fce4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428848",
      "title": "Community Adjacent To THPRD Nature Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0163c70999cbc15e7243e25e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428856",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7cee80767f92a7b256d0011",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80683631",
      "title": "Open 7 Days A Week",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a303da8841d43e799d09ab1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "82390161",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd63bf246bbc151145a8ca2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "82390163",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7831e620f4abd4529e58b35c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "86457317",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00ae220628a6f8771009cc58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428865",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-0c28-711a-a723-6ebc3308dd83.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer in a laundry closet with cabinets above.",
        "public_id": "019d496f-0c28-711a-a723-6ebc3308dd83",
        "storage_key": "property/6767906449166891/019d496f-0c28-711a-a723-6ebc3308dd83.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Elmonica Court vacant 2x1 washer and dryer, Beaverton, OR, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a76092a4d1c689e2fbe64bb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428863",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-3991-733a-9754-0e5f3ca3f0f5.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment building with walkway and manicured lawn.",
        "public_id": "019d496f-3991-733a-9754-0e5f3ca3f0f5",
        "storage_key": "property/6767906449166891/019d496f-3991-733a-9754-0e5f3ca3f0f5.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Elmonica Court building exterior decks and patios, Beaverton, OR, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0efc6de4ab848ced2b0a502e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428862",
      "title": "Attached Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_321ad8c4445271c3873fb584",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428864",
      "title": "Walk-In Closets - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eef0b832f51a5df3b3ebd2ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80428861",
      "title": "Vaulted Ceilings - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1087c28adf5a148aa62b4d9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "80683633",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496e-db59-76d0-9d22-ad1fe4b2c832.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white cabinets, black appliances, and a sliding glass door.",
        "public_id": "019d496e-db59-76d0-9d22-ad1fe4b2c832",
        "storage_key": "property/6767906449166891/019d496e-db59-76d0-9d22-ad1fe4b2c832.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Elmonica Court vacant 2x1 kitchen, Beaverton, OR, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f8d0f747db6dfe83b0414197",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "87310423",
      "title": "Built-In Vanity In Primary Bedroom - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496e-dd4e-75e9-abee-7d909cc9cde6.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with mirrored closet doors and vanity area.",
        "public_id": "019d496e-dd4e-75e9-abee-7d909cc9cde6",
        "storage_key": "property/6767906449166891/019d496e-dd4e-75e9-abee-7d909cc9cde6.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Elmonica Court vacant 2x1 primary bedroom vanity, Beaverton, OR, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73092cd7fbe2bd75a39ca4a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "yardi",
      "external_id": "87310418",
      "title": "Pool View - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-847f-736b-80f2-50d28c3ae72e.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas, with apartment buildings in the background.",
        "public_id": "019d496f-847f-736b-80f2-50d28c3ae72e",
        "storage_key": "property/6767906449166891/019d496f-847f-736b-80f2-50d28c3ae72e.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Elmonica Court seasonal swimming pool deck, Beaverton, OR , 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_6e39cd2816f2f08fac89ba4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d42a6-0923-76d5-92a0-c943b1cb17da.webp",
      "image_media": {
        "alt_text": "Elmonica apartment complex monument sign with landscaping.",
        "public_id": "019d42a6-0923-76d5-92a0-c943b1cb17da",
        "storage_key": "property/6767906449166891/019d42a6-0923-76d5-92a0-c943b1cb17da.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to Elmonica apartments, a beautiful community featuring lush landscaping and a prominent monument sign.",
      "link": "false",
      "alt_text": "Elmonica apartment complex monument sign with landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_MonumentSign.jpg"
    },
    {
      "id": "ec_8427df222578f1102f1e5f39",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496e-db59-76d0-9d22-ad1fe4b2c832.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black appliances, and a sliding glass door.",
        "public_id": "019d496e-db59-76d0-9d22-ad1fe4b2c832",
        "storage_key": "property/6767906449166891/019d496e-db59-76d0-9d22-ad1fe4b2c832.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring white cabinetry, black appliances, and ample counter space, with a sliding glass door leading to an outdoor area.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black appliances, and a sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_Kitchen.jpg"
    },
    {
      "id": "ec_bf695a7bd06255269c2eb420",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d1bfa-7af9-755b-b5f6-0ed4194833ad.webp",
      "image_media": {
        "alt_text": "Kitchen area with white cabinets, granite countertops, stainless steel sink, and black appliances.",
        "public_id": "019d1bfa-7af9-755b-b5f6-0ed4194833ad",
        "storage_key": "property/6767906449166891/019d1bfa-7af9-755b-b5f6-0ed4194833ad.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample white cabinetry, sleek granite countertops, and modern black appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen area with white cabinets, granite countertops, stainless steel sink, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_KitchenBar.jpg"
    },
    {
      "id": "ec_80545089d9b9fbf76ab7a220",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496e-db5a-775d-b182-813239813e2e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with neutral carpet and white cabinets.",
        "public_id": "019d496e-db5a-775d-b182-813239813e2e",
        "storage_key": "property/6767906449166891/019d496e-db5a-775d-b182-813239813e2e.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring a connected kitchen area with white cabinetry and appliances. Carpeted floors provide a cozy feel, leading to a spacious balcony.",
      "link": "false",
      "alt_text": "Living room and kitchen area with neutral carpet and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_KitchenDiningRoom.jpg"
    },
    {
      "id": "ec_e5dc137b6e50157715812fb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d1bfa-7aa8-766a-950a-eac37bd57a23.webp",
      "image_media": {
        "alt_text": "Spacious living room with carpeted floor and access to balcony.",
        "public_id": "019d1bfa-7aa8-766a-950a-eac37bd57a23",
        "storage_key": "property/6767906449166891/019d1bfa-7aa8-766a-950a-eac37bd57a23.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this spacious living area, perfect for relaxation and entertainment. Features a carpeted floor and easy access to your private outdoor space.",
      "link": "false",
      "alt_text": "Spacious living room with carpeted floor and access to balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_DiningRoomSlider.jpg"
    },
    {
      "id": "ec_8d086ea1892583af1d716ad3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496e-db5c-70c8-9bfc-9ba38570b5a8.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment living room with a white door and a large window",
        "public_id": "019d496e-db5c-70c8-9bfc-9ba38570b5a8",
        "storage_key": "property/6767906449166891/019d496e-db5c-70c8-9bfc-9ba38570b5a8.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living room with plush carpeting, a welcoming entryway, and a large window offering views of the surrounding greenery.",
      "link": "false",
      "alt_text": "Interior view of an apartment living room with a white door and a large window",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_Entry.jpg"
    },
    {
      "id": "ec_2599be3650c58b9da5ebe9b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496e-db5f-755e-abb4-9e8dcebc0208.webp",
      "image_media": {
        "alt_text": "Empty living room with carpet, a window overlooking trees, and two doors.",
        "public_id": "019d496e-db5f-755e-abb4-9e8dcebc0208",
        "storage_key": "property/6767906449166891/019d496e-db5f-755e-abb4-9e8dcebc0208.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting, a large window, and access to other rooms.",
      "link": "false",
      "alt_text": "Empty living room with carpet, a window overlooking trees, and two doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_LivingRoom.jpg"
    },
    {
      "id": "ec_4c5baab05da0ef8082a627a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496e-dd4e-75e9-abee-7d909cc9cde6.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and vanity area.",
        "public_id": "019d496e-dd4e-75e9-abee-7d909cc9cde6",
        "storage_key": "property/6767906449166891/019d496e-dd4e-75e9-abee-7d909cc9cde6.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large mirrored closet and an attached vanity area with sink and lighting.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and vanity area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_PrimaryBedroomVanity.jpg"
    },
    {
      "id": "ec_50b4236754aa9aa34dbc11b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-0a44-7568-b7aa-2f9bdbb7dc57.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a large window",
        "public_id": "019d496f-0a44-7568-b7aa-2f9bdbb7dc57",
        "storage_key": "property/6767906449166891/019d496f-0a44-7568-b7aa-2f9bdbb7dc57.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "A bright and airy empty bedroom, perfect for personalizing your new apartment. Features a large window with scenic views.",
      "link": "false",
      "alt_text": "Empty bedroom with a large window",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_PrimaryBedroom.jpg"
    },
    {
      "id": "ec_5fddcee087de366e3d6ea617",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-0c28-711a-a723-6ebc3308dd83.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet with cabinets above.",
        "public_id": "019d496f-0c28-711a-a723-6ebc3308dd83",
        "storage_key": "property/6767906449166891/019d496f-0c28-711a-a723-6ebc3308dd83.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer with overhead storage cabinets for your convenience.",
      "link": "false",
      "alt_text": "Washer and dryer in a laundry closet with cabinets above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_WasherDryer.jpg"
    },
    {
      "id": "ec_27ce78db9907b5bf7bb39b30",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-09d7-7152-8fb1-38ecc1061487.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment bedroom with a closet and an open door leading to another room.",
        "public_id": "019d496f-09d7-7152-8fb1-38ecc1061487",
        "storage_key": "property/6767906449166891/019d496f-09d7-7152-8fb1-38ecc1061487.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Apartment",
      "description": "This image shows the interior of an empty apartment bedroom, featuring a spacious closet and an open door that provides a glimpse into an adjacent room.",
      "link": "false",
      "alt_text": "Interior view of an empty apartment bedroom with a closet and an open door leading to another room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_SecondBedroom.jpg"
    },
    {
      "id": "ec_6e47485b208164cb6c82dbdc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-0eed-7314-b3b9-b80a769d3e9a.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and bathtub with shower.",
        "public_id": "019d496f-0eed-7314-b3b9-b80a769d3e9a",
        "storage_key": "property/6767906449166891/019d496f-0eed-7314-b3b9-b80a769d3e9a.webp",
        "width": 1463,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a spacious vanity with ample counter space, a comfortable toilet, and a bathtub with a shower, perfect for your daily routine.",
      "link": "false",
      "alt_text": "Bathroom with a vanity, toilet, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_Bathroom.jpg"
    },
    {
      "id": "ec_bce6900e2e61db00ba6091a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-1a40-706a-8dc8-57b0c2cf777c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with white siding and dark accents, surrounded by trees and lush landscaping.",
        "public_id": "019d496f-1a40-706a-8dc8-57b0c2cf777c",
        "storage_key": "property/6767906449166891/019d496f-1a40-706a-8dc8-57b0c2cf777c.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Showcasing the inviting exterior of the property, featuring clean white siding, modern dark accents, and beautiful mature trees, creating a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with white siding and dark accents, surrounded by trees and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_BuildingExteriorEntries.jpg"
    },
    {
      "id": "ec_b7c8f11db9d112ad8538c1fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-3991-733a-9754-0e5f3ca3f0f5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with walkway and manicured lawn.",
        "public_id": "019d496f-3991-733a-9754-0e5f3ca3f0f5",
        "storage_key": "property/6767906449166891/019d496f-3991-733a-9754-0e5f3ca3f0f5.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Walkway leading to the exterior of an apartment building, surrounded by green lawns and mature trees. Offers a glimpse of the property's welcoming grounds.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with walkway and manicured lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_PatiosDecks.jpg"
    },
    {
      "id": "ec_228ceb74f059743b1a2f3e65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-3fc4-76d8-bf1a-76314e09eec8.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with white siding, dark accents, and lush green trees.",
        "public_id": "019d496f-3fc4-76d8-bf1a-76314e09eec8",
        "storage_key": "property/6767906449166891/019d496f-3fc4-76d8-bf1a-76314e09eec8.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Charming exterior of the apartment building, surrounded by mature trees and well-maintained landscaping, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of a multifamily apartment building with white siding, dark accents, and lush green trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_BuildingExteriorCommunityWalkingPath.jpg"
    },
    {
      "id": "ec_77f8ac1dfacceb20f6ae182c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-3cae-779e-881e-b16adea0f337.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with parking lot and covered parking",
        "public_id": "019d496f-3cae-779e-881e-b16adea0f337",
        "storage_key": "property/6767906449166891/019d496f-3cae-779e-881e-b16adea0f337.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Exterior view of apartment building showing the building entrance, stairwells, and surrounding landscape. Includes a parking lot with marked spaces and covered parking.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with parking lot and covered parking",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_BuildingExteriorFront.jpg"
    },
    {
      "id": "ec_b210b2738c59009638a6239e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-3e23-73d9-bc43-9b26926bfe77.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with covered parking and lush trees.",
        "public_id": "019d496f-3e23-73d9-bc43-9b26926bfe77",
        "storage_key": "property/6767906449166891/019d496f-3e23-73d9-bc43-9b26926bfe77.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Charming apartment buildings surrounded by vibrant green trees, offering covered parking and serene community grounds.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with covered parking and lush trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_BuildingExteriorParkingLot.jpg"
    },
    {
      "id": "ec_f6963857d3f4d02cc35ba5d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-6dd9-7137-a88b-eeb6033fced9.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with covered parking and assigned parking spaces.",
        "public_id": "019d496f-6dd9-7137-a88b-eeb6033fced9",
        "storage_key": "property/6767906449166891/019d496f-6dd9-7137-a88b-eeb6033fced9.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring covered parking and ample assigned parking spaces for residents.",
      "link": "false",
      "alt_text": "Apartment building exterior with covered parking and assigned parking spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_ParkingLot.jpg"
    },
    {
      "id": "ec_78ffcab05f9dd2f9f7c9d2d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-7352-77a4-b8cc-a1da060800a2.webp",
      "image_media": {
        "alt_text": "Multiple garage doors in a row, with apartment buildings in the background.",
        "public_id": "019d496f-7352-77a4-b8cc-a1da060800a2",
        "storage_key": "property/6767906449166891/019d496f-7352-77a4-b8cc-a1da060800a2.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Covered parking is available for residents, offering convenience and protection for your vehicle.",
      "link": "false",
      "alt_text": "Multiple garage doors in a row, with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_Garages(1).jpg"
    },
    {
      "id": "ec_6d932f5c4a9e93189fabe87a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-7b83-702f-be1f-2fac9e7cbde9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding trees.",
        "public_id": "019d496f-7b83-702f-be1f-2fac9e7cbde9",
        "storage_key": "property/6767906449166891/019d496f-7b83-702f-be1f-2fac9e7cbde9.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable lounge chairs for ultimate relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_SwimmingPool.jpg"
    },
    {
      "id": "ec_5350ef473cd695426a0c7279",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-847f-736b-80f2-50d28c3ae72e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas, with apartment buildings in the background.",
        "public_id": "019d496f-847f-736b-80f2-50d28c3ae72e",
        "storage_key": "property/6767906449166891/019d496f-847f-736b-80f2-50d28c3ae72e.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush greenery and comfortable lounge seating. Enjoy the sunshine or take a refreshing dip.",
      "link": "false",
      "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas, with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_SwimmingPoolDeck.jpg"
    },
    {
      "id": "ec_03990ae5997ac4f6cd6b9b72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-82eb-749a-8c04-f862993a9252.webp",
      "image_media": {
        "alt_text": "Elmonica Court package lockers",
        "public_id": "019d496f-82eb-749a-8c04-f862993a9252",
        "storage_key": "property/6767906449166891/019d496f-82eb-749a-8c04-f862993a9252.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Secure package lockers for residents at Elmonica Court, offering convenient package pickup.",
      "link": "false",
      "alt_text": "Elmonica Court package lockers",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_SelfServicePackageLockers.jpg"
    },
    {
      "id": "ec_f9ceb869326f46a3b605d19c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-a5b3-76ca-b61d-b9c3d5c9891a.webp",
      "image_media": {
        "alt_text": "Mailboxes in a covered outdoor area at a multifamily property.",
        "public_id": "019d496f-a5b3-76ca-b61d-b9c3d5c9891a",
        "storage_key": "property/6767906449166891/019d496f-a5b3-76ca-b61d-b9c3d5c9891a.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Secure and accessible mailboxes for residents, conveniently located under a covered structure for protection from the elements.",
      "link": "false",
      "alt_text": "Mailboxes in a covered outdoor area at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_MailStation(1).jpg"
    },
    {
      "id": "ec_6562e1b9669c23a7f9d921d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d496f-b48f-7354-b4ec-974286e1718b.webp",
      "image_media": {
        "alt_text": "View of the property's exterior with green grass, trees, and parking lot.",
        "public_id": "019d496f-b48f-7354-b4ec-974286e1718b",
        "storage_key": "property/6767906449166891/019d496f-b48f-7354-b4ec-974286e1718b.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy the beautiful outdoor spaces and well-maintained grounds of our community, featuring ample parking and lush landscaping.",
      "link": "false",
      "alt_text": "View of the property's exterior with green grass, trees, and parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/ElmonicaCourt_Beaverton_OR_WalkingTrail.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_cdc10c38-36eb-485d-ba8f-c741c5cd09c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Topgolf Hillsboro",
      "poi_type": "Restaurants",
      "poi_address": "5505 NE Huffman St, Hillsboro, OR 97124, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with heated bays, a variety of games, and tasty appetizers. They highlight the affordable prices and relaxed atmosphere, suitable for families and groups. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-29ba-7346-a45a-b5eccfb04ca0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-29ba-7346-a45a-b5eccfb04ca0",
        "storage_key": "property/6767906449166891/019d08ad-29ba-7346-a45a-b5eccfb04ca0.webp",
        "width": 1000,
        "height": 686
      },
      "poi_business_url": "https://topgolf.com/us/hillsboro/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5590872944195421069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-hillsboro",
      "poi_latitude": "45.55978169999999",
      "poi_longitude": "-122.9240849",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-549-5197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1dd-759d-98b9-a73ebcb02c58",
        "storage_key": "property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtY7HRqQFlVQRjUMcL1LFlk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_df22b670-0561-4bf5-ab2a-eeb3b5daa8ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "9309 SW Washington Square Rd, Tigard, OR 97223, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "Diners say this restaurant offers a wide variety of dishes, including Bang Bang Chicken and Shrimp, cheesecake, and pasta, with many praising the extensive menu and delicious food. They also highlight the friendly and attentive service, and the vibrant and comfortable atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-29e8-758e-aca4-b26f1f051fcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-29e8-758e-aca4-b26f1f051fcc",
        "storage_key": "property/6767906449166891/019d08ad-29e8-758e-aca4-b26f1f051fcc.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/or/tigard-101.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=9275120421759837335&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "45.4510321",
      "poi_longitude": "-122.7823753",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-620-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1dd-759d-98b9-a73ebcb02c58",
        "storage_key": "property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6omzVcMlVQRl2T3w-HYt4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_021d8cd2-0f0c-4a03-9837-ec857812a877",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "10657 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches, nuggets, and waffle fries. They highlight the reasonable prices, convenient location, and ample parking. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-29ee-76f8-a65a-409da6bf9d11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-29ee-76f8-a65a-409da6bf9d11",
        "storage_key": "property/6767906449166891/019d08ad-29ee-76f8-a65a-409da6bf9d11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/or/raleigh-hills?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=16597217422825337868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "45.4869133",
      "poi_longitude": "-122.7862333",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-305-9158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1dd-759d-98b9-a73ebcb02c58",
        "storage_key": "property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9onNxANlVQRDLRta08pVeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c16d3622-fd2b-4d3b-a281-db7f031fbe73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Din Tai Fung",
      "poi_type": "Restaurants",
      "poi_address": "9724 SW Washington Square Rd, Tigard, OR 97223, USA",
      "poi_short_description": "Upscale eatery specializing in Taiwanese dumplings with soup, steamed dumplings, noodle dishes, fried rice and rice cakes.",
      "poi_long_description": "People say this Chinese restaurant serves delicious soup dumplings, garlic green beans, and noodles. They highlight the fast service and friendly staff. They also like the clean and modern atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-29ee-76f8-a65a-478bec03f7cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-29ee-76f8-a65a-478bec03f7cc",
        "storage_key": "property/6767906449166891/019d08ad-29ee-76f8-a65a-478bec03f7cc.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://dtf.com/en/locations/tigard",
      "poi_directions_map_url": "https://maps.google.com/?cid=7925850032975282981&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "din-tai-fung",
      "poi_latitude": "45.4486876",
      "poi_longitude": "-122.7813741",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-768-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1dd-759d-98b9-a73ebcb02c58",
        "storage_key": "property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJra5u8yENlVQRJYOCrpxG_m0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_85a4afca-d526-412c-a3a8-56b352d5ac18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "BGs Food Cartel",
      "poi_type": "Restaurants",
      "poi_address": "4250 SW Rose Biggi Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "Open-air space with over 30 international food trucks, plus an indoor/outdoor speakeasy-style bar.",
      "poi_long_description": "People say this restaurant offers tasty brisket, pork fried rice, and potstickers. They highlight the generous portions, the variety of food trucks, and the family-friendly atmosphere with a kids' play area and ample seating. They also like the clean restrooms and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-4a6e-76f4-97b5-b56979bec7cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4a6e-76f4-97b5-b56979bec7cd",
        "storage_key": "property/6767906449166891/019d08ac-4a6e-76f4-97b5-b56979bec7cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bgfoodcartel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13359900484536572783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bgs-food-cartel",
      "poi_latitude": "45.4892645",
      "poi_longitude": "-122.8081145",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-605-9163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1dd-759d-98b9-a73ebcb02c58",
        "storage_key": "property/6767906449166891/019d08ac-e1dd-759d-98b9-a73ebcb02c58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJSQIYZ8OlVQRbxtf97TmZ7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d9d5c21e-cfa6-4453-9174-b4d46f3df6d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Washington Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "9585 SW Washington Square Rd, Portland, OR 97223, USA",
      "poi_short_description": "Large shopping center with a variety of department stores, specialty shops & food options.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and services, including a Cheesecake Factory, a Lego store, and a variety of clothing stores. They also highlight the clean and well-maintained environment, the friendly and helpful staff, and the convenient parking.\n\nOther reviews mention the food court can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-3087-779b-b057-ce56e13f9e55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-3087-779b-b057-ce56e13f9e55",
        "storage_key": "property/6767906449166891/019d08ad-3087-779b-b057-ce56e13f9e55.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.shopwashingtonsquare.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8036230870585529003&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washington-square",
      "poi_latitude": "45.4502491",
      "poi_longitude": "-122.7812183",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-639-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e7ed-75d8-a3ac-3b45bb1341c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e7ed-75d8-a3ac-3b45bb1341c2",
        "storage_key": "property/6767906449166891/019d08ac-e7ed-75d8-a3ac-3b45bb1341c2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy9M2zVcMlVQRq1JHJmZthm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_439c2769-25e6-491b-b9bd-a2be710de23f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Uwajimaya Beaverton",
      "poi_type": "Shopping & Retail",
      "poi_address": "10500 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Perennial Asian grocery stocking meats, produce & prepared foods, plus gifts & home goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh seafood, produce, and Japanese groceries, including musubi, onigiri, and poke. They highlight the friendly and helpful staff, and the fun, unique shopping experience. They also like the bookstore in the back and the delicious hot food options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-30bb-706f-a4de-a54038babf70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-30bb-706f-a4de-a54038babf70",
        "storage_key": "property/6767906449166891/019d08ad-30bb-706f-a4de-a54038babf70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/beaverton/?utm_source=localprofiles&utm_medium=organic&utm_content=beaverton&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=6570527899701517362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-beaverton",
      "poi_latitude": "45.48564529999999",
      "poi_longitude": "-122.7849074",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-643-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e81d-7448-a1c2-5a8248743cb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e81d-7448-a1c2-5a8248743cb3",
        "storage_key": "property/6767906449166891/019d08ac-e81d-7448-a1c2-5a8248743cb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVB9wAQMlVQRMpyACFA0L1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_16307a0b-9e14-47d1-b6b9-db88e0c7c48b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Columbia Sportswear Company Employee Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "14100 NW Science Park Dr, Portland, OR 97229, USA",
      "poi_short_description": "Spacious shop carrying jackets, hoodies and other mountain-ready pieces from Patagonia, Sorel and prAna.",
      "poi_long_description": "People say this sportswear store offers a wide selection of products from brands like Columbia, Mountain Hardwear, and Sorel. They highlight the great deals and discounts, especially for those with employee access, and the clean, well-organized layout. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-30ab-715d-a999-7d176e6a5b47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-30ab-715d-a999-7d176e6a5b47",
        "storage_key": "property/6767906449166891/019d08ad-30ab-715d-a999-7d176e6a5b47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.columbia.com/or/portland/employee-store-425",
      "poi_directions_map_url": "https://maps.google.com/?cid=2313366469886134804&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "columbia-sportswear-company-employee-store",
      "poi_latitude": "45.5261922",
      "poi_longitude": "-122.8234194",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-985-4125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e7ed-75d8-a3ac-3b45bb1341c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e7ed-75d8-a3ac-3b45bb1341c2",
        "storage_key": "property/6767906449166891/019d08ac-e7ed-75d8-a3ac-3b45bb1341c2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbxyE2yoPlVQRFMrcMIy6GiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_c6bf7dac-b8d8-4261-ab3e-f8513113310b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3025 SW Cedar Hills Blvd, Beaverton, OR 97005, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide selection of groceries, including a large bulk section, and fresh produce. They also highlight the affordable prices, convenient 24-hour service, and friendly staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-6e97-74ab-bc52-10ec2a6a06e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-6e97-74ab-bc52-10ec2a6a06e4",
        "storage_key": "property/6767906449166891/019d08ac-6e97-74ab-bc52-10ec2a6a06e4.webp",
        "width": 1280,
        "height": 744
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15287079724831147658&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "45.49809399999999",
      "poi_longitude": "-122.810114",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-644-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e81d-7448-a1c2-5a8248743cb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e81d-7448-a1c2-5a8248743cb3",
        "storage_key": "property/6767906449166891/019d08ac-e81d-7448-a1c2-5a8248743cb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk19IebsOlVQRigaj6wOeJtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8daa0753-3b2f-416f-ba0a-7a119ed35a5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "99 Ranch Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "8155 SW Hall Blvd, Beaverton, OR 97008, USA",
      "poi_short_description": "Asian supermarket chain carrying imported specialty foods plus meat, seafood, produce & baked goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, seafood, meat, and Asian packaged foods, as well as a deli with dim sum and a bakery. They also highlight the fair prices, the availability of coupons, and the helpful cashiers.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-33f5-7728-a95a-d33a6749aaf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-33f5-7728-a95a-d33a6749aaf7",
        "storage_key": "property/6767906449166891/019d08ad-33f5-7728-a95a-d33a6749aaf7.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://99ranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16482590746551729438&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "99-ranch-market",
      "poi_latitude": "45.4602283",
      "poi_longitude": "-122.7966848",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-605-1899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e81d-7448-a1c2-5a8248743cb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e81d-7448-a1c2-5a8248743cb3",
        "storage_key": "property/6767906449166891/019d08ac-e81d-7448-a1c2-5a8248743cb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqROpYk4MlVQRHj1bmvTsveQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_86c13808-17c4-4ead-9333-04d90e00b23a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Beaverton City Library",
      "poi_type": "Education",
      "poi_address": "12375 SW 5th St, Beaverton, OR 97005, USA",
      "poi_short_description": "Multistory library with kids' areas, computers and board game rentals.",
      "poi_long_description": "People say this public library offers a wide selection of books, music CDs, DVDs/Blu-rays, and video games, as well as digital resources and a \"Library of Things.\" They highlight the spacious layout, beautiful architecture, and numerous working, studying, and reading spaces, including a dedicated children's area with storytime rooms. They also like the friendly and helpful staff, and the various activities and events for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-3731-76dd-8636-7223019caca0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-3731-76dd-8636-7223019caca0",
        "storage_key": "property/6767906449166891/019d08ad-3731-76dd-8636-7223019caca0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://beavertonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2456838086164544331&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-city-library",
      "poi_latitude": "45.4840984",
      "poi_longitude": "-122.804071",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-644-2197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-ed29-77dd-a19e-0f29c17353e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-ed29-77dd-a19e-0f29c17353e0",
        "storage_key": "property/6767906449166891/019d08ac-ed29-77dd-a19e-0f29c17353e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv_YnSyAMlVQRS_t89DhxGCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d573e93e-3726-4dcd-a4ef-314db5b19891",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Portland Community College Rock Creek",
      "poi_type": "Education",
      "poi_address": "17705 NW Springville Rd, Portland, OR 97229, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-890d-71af-b893-cdee24b7e51f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-890d-71af-b893-cdee24b7e51f",
        "storage_key": "property/6767906449166891/019d08ac-890d-71af-b893-cdee24b7e51f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pcc.edu/about/locations/rock-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3966148189600444475&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-community-college-rock-creek",
      "poi_latitude": "45.5668982",
      "poi_longitude": "-122.8604923",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 971-722-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-ed29-77dd-a19e-0f29c17353e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-ed29-77dd-a19e-0f29c17353e0",
        "storage_key": "property/6767906449166891/019d08ac-ed29-77dd-a19e-0f29c17353e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzascJg8GlVQRO3Cxz8OWCjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4b24df57-9d84-4ed2-ad28-f5cbf47905d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Hillsboro Brookwood Library",
      "poi_type": "Education",
      "poi_address": "2850 NE Brookwood Pkwy, Hillsboro, OR 97124, USA",
      "poi_short_description": "Duck pond, quiet rooms, books and musical instruments are all offered at this library.",
      "poi_long_description": "People say this public library offers a wide selection of books, movies, and tools, as well as reservable study rooms, a Collaboratory, and free access to online resources. They highlight the beautiful building with scenic views, the clean and updated facilities, and the many options for study and community activities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-37d7-744c-90ab-fabe3b6fe548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-37d7-744c-90ab-fabe3b6fe548",
        "storage_key": "property/6767906449166891/019d08ad-37d7-744c-90ab-fabe3b6fe548.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wccls.org/libraries/hillsborobrookwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=12017357779366618812&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillsboro-brookwood-library",
      "poi_latitude": "45.542883",
      "poi_longitude": "-122.9360009",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-615-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-ed29-77dd-a19e-0f29c17353e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-ed29-77dd-a19e-0f29c17353e0",
        "storage_key": "property/6767906449166891/019d08ac-ed29-77dd-a19e-0f29c17353e0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJswhUZ24FlVQRvKbsyTo7xqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b16cdde6-0ada-4813-9276-b44b8958feea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Witch's Castle",
      "poi_type": "Entertainment",
      "poi_address": "Lower Macleay Trail, Portland, OR 97210, USA",
      "poi_short_description": "On the Lower Macleay Trail, this old stone building with no roof is surrounded by dense woodland.",
      "poi_long_description": "People say this historical landmark offers a short, scenic hike to a castle. They also highlight the graffiti adds to the unique and mysterious atmosphere, and the trail is easy and enjoyable for all ages.\n\nOther reviews mention the castle can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-39a8-73b7-898f-44b5716fa169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-39a8-73b7-898f-44b5716fa169",
        "storage_key": "property/6767906449166891/019d08ad-39a8-73b7-898f-44b5716fa169.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portlandoregon.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16975484436389670400&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "witchs-castle",
      "poi_latitude": "45.5283626",
      "poi_longitude": "-122.7250661",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-823-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09XitZYJlVQRAK4tqScJles",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_3984bb4e-f135-4968-823b-cafe516b5134",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Hillsboro Stadium",
      "poi_type": "Entertainment",
      "poi_address": "4450 NE Century Blvd, Hillsboro, OR 97124, USA",
      "poi_short_description": "Sports stadium with concerts, graduation, and other events, as well as wheelchair seating.",
      "poi_long_description": "People say this stadium offers remarkable baseball and softball fields, and a grass area for families to relax. They highlight the reasonable prices, good atmosphere, and clean facilities. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-397e-7023-baa2-1df83b43c821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-397e-7023-baa2-1df83b43c821",
        "storage_key": "property/6767906449166891/019d08ad-397e-7023-baa2-1df83b43c821.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "http://www.hillsboro-oregon.gov/departments/parks-recreation/our-facilities/gordon-faber-recreation-complex",
      "poi_directions_map_url": "https://maps.google.com/?cid=9475876756446806181&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillsboro-stadium",
      "poi_latitude": "45.5543523",
      "poi_longitude": "-122.9070216",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-681-6120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-731a-774f-a1de-ab4db813bc4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-731a-774f-a1de-ab4db813bc4b",
        "storage_key": "property/6767906449166891/019d08ad-731a-774f-a1de-ab4db813bc4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr_ABr5cFlVQRpYBkY7QTgYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_93f50052-c877-4a81-93f8-d6d4476ee5f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Play Street Museum - Beaverton",
      "poi_type": "Entertainment",
      "poi_address": "11221 NE Evergreen Pkwy Suite F, Hillsboro, OR 97006, USA",
      "poi_short_description": "Interactive museum and play area with educational exhibits and activities for kids 8 and under.",
      "poi_long_description": "People say this children's museum offers a variety of engaging activities, including imaginative play areas, wooden riding toys, and building and art activities. They highlight the clean, safe, and well-organized environment, and the friendly and helpful staff. They also like the calm and inviting atmosphere, perfect for children of all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-3f8c-76fa-956d-bcf11874f780.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-3f8c-76fa-956d-bcf11874f780",
        "storage_key": "property/6767906449166891/019d08ad-3f8c-76fa-956d-bcf11874f780.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://beaverton.playstreetmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13212348074487731780&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "play-street-museum---beaverton",
      "poi_latitude": "45.5370712",
      "poi_longitude": "-122.8625165",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-470-3229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-ee94-77bf-a9fd-a43c184c8ba4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-ee94-77bf-a9fd-a43c184c8ba4",
        "storage_key": "property/6767906449166891/019d08ac-ee94-77bf-a9fd-a43c184c8ba4.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRd4XlVwPlVQRRFaoXJKwW7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7ae192c4-9ef5-43b6-8cfa-8a6c6271d3e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Oregon Airsoft Arena",
      "poi_type": "Entertainment",
      "poi_address": "1600 NE 25th Ave Ste A, Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-3ff7-74ba-8e73-413901c53e7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-3ff7-74ba-8e73-413901c53e7a",
        "storage_key": "property/6767906449166891/019d08ad-3ff7-74ba-8e73-413901c53e7a.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://oregon-airsoft.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6205847157706606627&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oregon-airsoft-arena",
      "poi_latitude": "45.536941",
      "poi_longitude": "-122.956495",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-985-8326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4BQN0QFlVQRI0h4JRyZH1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_394c72e5-7442-4572-b6ec-08c929556e67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Fogelbo Historic Log Home",
      "poi_type": "Entertainment",
      "poi_address": "Portland, OR 97223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-42cf-703f-ba86-1196c426249c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-42cf-703f-ba86-1196c426249c",
        "storage_key": "property/6767906449166891/019d08ad-42cf-703f-ba86-1196c426249c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nordicnorthwest.org/fogelbo",
      "poi_directions_map_url": "https://maps.google.com/?cid=11192867665588144266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fogelbo-historic-log-home",
      "poi_latitude": "45.4566478",
      "poi_longitude": "-122.7666597",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-977-0275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3ptVvUMlVQRikhW6dYNVZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_a5c4ce29-2cc8-4077-91cf-c4120c6ef173",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "600 SW 116th Ave, Portland, OR 97225, USA",
      "poi_short_description": "Athletic country club chain in Cedar Mill with a gym, an outdoor beach club, pools, basketball and pickleball courts, and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of classes, top-notch equipment, and multiple pools, including an adults-only option, and provides convenient amenities like a cafe, lounge, and clean locker rooms with saunas and plunge pools.\n\nOther reviews mention the price can be high and the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-4428-7333-ba78-362f0f1062cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-4428-7333-ba78-362f0f1062cf",
        "storage_key": "property/6767906449166891/019d08ad-4428-7333-ba78-362f0f1062cf.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/or/beaverton.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=8291423413939196135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "45.5153662",
      "poi_longitude": "-122.7940413",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-616-9950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88xwwvQJlVQR59AzRqoNEXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dcf6bd88-05f5-4523-b177-6c0e9ec05837",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1265 NW Waterhouse Ave, Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of classes, including Zumba, and has friendly staff and instructors.\n\nOther reviews mention the facilities can be crowded and the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-46bf-734b-8ce7-878662c666b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-46bf-734b-8ce7-878662c666b2",
        "storage_key": "property/6767906449166891/019d08ad-46bf-734b-8ce7-878662c666b2.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/beaverton-or/tanasbourne-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=11710869471339348612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.5275512",
      "poi_longitude": "-122.8373563",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-207-0452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0wx9jkPlVQRhAImwrxdhaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6d51b073-0361-4eee-93a5-9af069d95ab7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "13900 SW Meridian St, Beaverton, OR 97005, USA",
      "poi_short_description": "Large, resort-like, family-oriented recreation center featuring a gym, plus numerous clean pools (indoors and out), a hot tub and a sauna.",
      "poi_long_description": "People say this gym offers a variety of pools, fitness classes, and amenities, including a steam room, sauna, and hot tubs. They also highlight the family-friendly vibe, the dedicated instructors, and the welcoming staff.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-4947-72a6-a097-b1027d974f30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-4947-72a6-a097-b1027d974f30",
        "storage_key": "property/6767906449166891/019d08ad-4947-72a6-a097-b1027d974f30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.villasport.com/beaverton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6712726625660967216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "45.5039949",
      "poi_longitude": "-122.8247248",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 971-317-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaSSIqMEOlVQRMBnU7ExlKF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0ed127dc-5480-4ce7-a946-10c413c4cdd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2800 SW Hocken Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain offering treadmills, swimming pools. basketball courts and strength equipment.",
      "poi_long_description": "People say this gym offers a pool and swim aerobic classes.\n\nOther reviews mention the facility can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-4be4-7268-a030-7c0cfe8c11a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-4be4-7268-a030-7c0cfe8c11a9",
        "storage_key": "property/6767906449166891/019d08ad-4be4-7268-a030-7c0cfe8c11a9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=324&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12600149306380626618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "45.4994817",
      "poi_longitude": "-122.8128318",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-627-0737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0dUPA7wOlVQRuqqzIwm53K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d509b1b6-43f2-4855-9dda-b023858d2135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "3255 SW Cedar Hills Blvd #150, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-4d04-736f-b09e-2d29affce07f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-4d04-736f-b09e-2d29affce07f",
        "storage_key": "property/6767906449166891/019d08ad-4d04-736f-b09e-2d29affce07f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/beaverton-or-188",
      "poi_directions_map_url": "https://maps.google.com/?cid=18015545214605731550&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "45.4959133",
      "poi_longitude": "-122.8109335",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-643-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-pEp7wOlVQR3iaQF-wSBPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_28960073-b3d2-4b92-9200-35a488606fb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "20225 SW Tualatin Valley Hwy, Aloha, OR 97003, USA",
      "poi_short_description": "Membership-only gym in the Aloha Market Center offering massage chairs and tanning.",
      "poi_long_description": "People say this gym offers a wide variety of clean equipment and a spacious workout area.\n\nOther reviews mention the staff can be unhelpful and the facility can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-ac99-7624-a7ea-d23ba2b0c06c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-ac99-7624-a7ea-d23ba2b0c06c",
        "storage_key": "property/6767906449166891/019d08ac-ac99-7624-a7ea-d23ba2b0c06c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6479232219866472316&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.4967159",
      "poi_longitude": "-122.8854284",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-608-7286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRXoL0QPlVQRfB9oImDb6lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d5a9d094-8fd0-478f-851b-8c8cf6da15fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Tanasbourne Veterinary Emergency",
      "poi_type": "Health and Wellness",
      "poi_address": "17400 NW Corridor Ct, Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-5178-7788-85be-ab7ca0c680fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-5178-7788-85be-ab7ca0c680fa",
        "storage_key": "property/6767906449166891/019d08ad-5178-7788-85be-ab7ca0c680fa.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.tanasbourneveter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10792964979161014890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tanasbourne-veterinary-emergency",
      "poi_latitude": "45.536718",
      "poi_longitude": "-122.8560594",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-629-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn9EvFGUPlVQRaqIfCHdQyJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_f43334b8-611b-4401-9320-013ff0eb0ecd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Providence St. Vincent Hospital East Pavilion",
      "poi_type": "Health and Wellness",
      "poi_address": "9155 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-52d7-70c9-beef-d2578660f3fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-52d7-70c9-beef-d2578660f3fb",
        "storage_key": "property/6767906449166891/019d08ad-52d7-70c9-beef-d2578660f3fb.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://oregon.providence.org/location-directory/p/providence-st-vincent-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5100053104868075598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-st-vincent-hospital-east-pavilion",
      "poi_latitude": "45.510411",
      "poi_longitude": "-122.7701193",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-216-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-f367-7143-94b8-102c8ddc9a8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-f367-7143-94b8-102c8ddc9a8c",
        "storage_key": "property/6767906449166891/019d08ac-f367-7143-94b8-102c8ddc9a8c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQXvYkMJlVQRTihKE0cHx0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_07b7845d-e842-4291-a991-959d3ab4fcb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Providence St. Vincent Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9205 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-535f-7456-ab45-3c63d3074468.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-535f-7456-ab45-3c63d3074468",
        "storage_key": "property/6767906449166891/019d08ad-535f-7456-ab45-3c63d3074468.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.providence.org/locations/or/st-vincent-medical-center?ls=location&y_source=1_OTU3NjM5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1736548786178364168&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-st-vincent-medical-center",
      "poi_latitude": "45.5103299",
      "poi_longitude": "-122.7720125",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-216-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-f367-7143-94b8-102c8ddc9a8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-f367-7143-94b8-102c8ddc9a8c",
        "storage_key": "property/6767906449166891/019d08ac-f367-7143-94b8-102c8ddc9a8c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QPVf0QJlVQRCBNMn-t1GRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_54856b24-366d-4971-97d6-df60f7d0bc4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "RedTail Golf Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8200 SW Scholls Ferry Rd, Beaverton, OR 97008, USA",
      "poi_short_description": "Golf center at an 18-hole course offering practice facilities, lessons, a pro shop & an eatery.",
      "poi_long_description": "People say this golf course offers a well-stocked pro shop, a driving range with TrackMan technology, and professional lessons. They also highlight the friendly and helpful staff, and the quick turnaround for services like regripping.\n\nOther reviews mention the course can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-54cc-75da-84b3-763eb654a1d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-54cc-75da-84b3-763eb654a1d3",
        "storage_key": "property/6767906449166891/019d08ad-54cc-75da-84b3-763eb654a1d3.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://golfredtail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15748737038652720950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "redtail-golf-center",
      "poi_latitude": "45.4608887",
      "poi_longitude": "-122.778375",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-646-5166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-74cf-733e-b2ea-9ffe345c2c9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-74cf-733e-b2ea-9ffe345c2c9c",
        "storage_key": "property/6767906449166891/019d08ad-74cf-733e-b2ea-9ffe345c2c9c.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJTYBlhF4MlVQRNsfuceXAjto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_2bfe2543-5d3b-4211-9084-4c83440a84ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Tualatin Hills Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15655 SW Millikan Way, Beaverton, OR 97006, USA",
      "poi_short_description": "Hiking & biking trails along with playgrounds & sports facilities in a family-friendly public park.",
      "poi_long_description": "People say this park offers a variety of trails, including paved, unpaved, and boardwalk options, and is a great place to see birds and other wildlife. They highlight the well-maintained trails, clean restrooms, and the abundance of shade provided by the trees. They also like the interactive visitor center and the peaceful, rejuvenating atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-9424-7639-863c-928236a51e33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-9424-7639-863c-928236a51e33",
        "storage_key": "property/6767906449166891/019d08ac-9424-7639-863c-928236a51e33.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/tualatin-hills-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17581483943034553182&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tualatin-hills-nature-park",
      "poi_latitude": "45.4982312",
      "poi_longitude": "-122.8396247",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-645-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-ed82-77fd-a4ca-2a0f2e7f52ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-ed82-77fd-a4ca-2a0f2e7f52ac",
        "storage_key": "property/6767906449166891/019d08ac-ed82-77fd-a4ca-2a0f2e7f52ac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWfj9vvMOlVQRXgPP2H76_fM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_61561412-4ca3-4bbd-a20c-b3b348a88311",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Hidden Creek Park West",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "225 NE 53rd Ave, Hillsboro, OR 97124, USA",
      "poi_short_description": "Playground featuring a giant wooden spider along with slides, an obstacle course, and a climbing wall.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including a monkey structure, sand pit, swings, and slides, as well as a river area and green space. They highlight the park is fenced, clean, and well-maintained, with restrooms and benches. They also like the inclusive design, with features suitable for children of all ages and abilities, and the ASL learning board.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-5be5-765f-ae60-dc8e9a1f8b1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-5be5-765f-ae60-dc8e9a1f8b1d",
        "storage_key": "property/6767906449166891/019d08ad-5be5-765f-ae60-dc8e9a1f8b1d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hillsboro-oregon.gov/Home/Components/FacilityDirectory/FacilityDirectory/186/3979",
      "poi_directions_map_url": "https://maps.google.com/?cid=9381244287606704348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hidden-creek-park-west",
      "poi_latitude": "45.52244270000001",
      "poi_longitude": "-122.9300293",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-681-6120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-ed82-77fd-a4ca-2a0f2e7f52ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-ed82-77fd-a4ca-2a0f2e7f52ac",
        "storage_key": "property/6767906449166891/019d08ac-ed82-77fd-a4ca-2a0f2e7f52ac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJD3A2choPlVQR3Mj1wfnfMII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4607abfe-ed76-46bc-b5d1-db86f7a89871",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "The Reserve Vineyard & Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4805 SW 229th Ave, Aloha, OR 97007, USA",
      "poi_short_description": "Twin public golf courses with a clubhouse restaurant overlooking a creek & vineyard.",
      "poi_long_description": "People say this golf course offers two beautiful, well-maintained courses with fast greens. They highlight the good pace of play, delicious food, and beautiful patio. They also like the friendly and attentive staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-5a0a-742d-b1cf-f349e1fc4392.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-5a0a-742d-b1cf-f349e1fc4392",
        "storage_key": "property/6767906449166891/019d08ad-5a0a-742d-b1cf-f349e1fc4392.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.reservegolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=320024539318904576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-reserve-vineyard--golf-club",
      "poi_latitude": "45.4849057",
      "poi_longitude": "-122.9181504",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-649-8191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-74cf-733e-b2ea-9ffe345c2c9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-74cf-733e-b2ea-9ffe345c2c9c",
        "storage_key": "property/6767906449166891/019d08ad-74cf-733e-b2ea-9ffe345c2c9c.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWPQUNERlVQRAOeCeZ_0cAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_ea2c57b4-9fe2-4440-b669-44d5de5c0cf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Cooper Mountain Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18892 SW Kemmer Rd #5682, Beaverton, OR 97007, USA",
      "poi_short_description": "Scenic 230-acre park overlooking the river with multiple habitats, hiking trails & nature programs.",
      "poi_long_description": "People say this park offers well-maintained trails with beautiful views, perfect for hiking and birdwatching. They highlight the diverse trail options, the opportunity to see wildlife like deer, and the peaceful atmosphere. They also like the convenient amenities, such as a playground and wooden seats along the trails. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-baba-77be-9e69-2206d4086d46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-baba-77be-9e69-2206d4086d46",
        "storage_key": "property/6767906449166891/019d08ac-baba-77be-9e69-2206d4086d46.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/cooper-mountain-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=899869489749514377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cooper-mountain-nature-park",
      "poi_latitude": "45.4524826",
      "poi_longitude": "-122.8712162",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-629-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-ed82-77fd-a4ca-2a0f2e7f52ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-ed82-77fd-a4ca-2a0f2e7f52ac",
        "storage_key": "property/6767906449166891/019d08ac-ed82-77fd-a4ca-2a0f2e7f52ac.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZxuDwwSlVQRiVi7gIj6fAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_66249fee-8f0e-4f14-aa62-8041e1115273",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Hillsboro Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3355 NE Cornell Rd, Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-5c98-762c-b47e-cfb11b9c9a2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-5c98-762c-b47e-cfb11b9c9a2a",
        "storage_key": "property/6767906449166891/019d08ad-5c98-762c-b47e-cfb11b9c9a2a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.portofportland.com/HIO",
      "poi_directions_map_url": "https://maps.google.com/?cid=6464888335436437604&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillsboro-airport",
      "poi_latitude": "45.5329479",
      "poi_longitude": "-122.9479571",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-693-1963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-764d-73bb-b2ac-a8ff9b2b7418.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ad-764d-73bb-b2ac-a8ff9b2b7418",
        "storage_key": "property/6767906449166891/019d08ad-764d-73bb-b2ac-a8ff9b2b7418.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXsGe1sFlVQRZFhBSrDlt1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_a1d36954-d988-4b1c-bcb1-92455003c2c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Beaverton TC MAX Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-c30f-70a0-94b4-145c314acd2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-c30f-70a0-94b4-145c314acd2e",
        "storage_key": "property/6767906449166891/019d08ac-c30f-70a0-94b4-145c314acd2e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9821",
      "poi_directions_map_url": "https://maps.google.com/?cid=13913915888813031590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-tc-max-station",
      "poi_latitude": "45.4914575",
      "poi_longitude": "-122.8016546",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ7Mt6YOlVQRpkBdI8goGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_973a0d62-6c6c-4917-984d-ae01a26b60b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Quatama",
      "poi_type": "Transportation & Transit",
      "poi_address": "350 SW 205th Ave, Hillsboro, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-6012-7559-a3c8-41772f30aa75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-6012-7559-a3c8-41772f30aa75",
        "storage_key": "property/6767906449166891/019d08ad-6012-7559-a3c8-41772f30aa75.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?stop_id=9833",
      "poi_directions_map_url": "https://maps.google.com/?cid=2211718111633100831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quatama",
      "poi_latitude": "45.523201",
      "poi_longitude": "-122.888821",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfph5J8PlVQRH1Awg-eZsR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_0b9592b8-4e36-4575-ae19-2ba5fa2dbaab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Orenco MAX",
      "poi_type": "Transportation & Transit",
      "poi_address": "Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-6121-733e-804f-055ab5104b37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-6121-733e-804f-055ab5104b37",
        "storage_key": "property/6767906449166891/019d08ad-6121-733e-804f-055ab5104b37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?stop_id=9835",
      "poi_directions_map_url": "https://maps.google.com/?cid=13474446335283984598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "orenco-max",
      "poi_latitude": "45.530296",
      "poi_longitude": "-122.9158316",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-238-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSFaAoYPlVQR1niqH43Z_ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_a8f0b158-a3e0-471f-a104-c72ffc70cb78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Elmonica/SW 170th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-c1e7-71cc-9358-a8b4c9bbf16e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-c1e7-71cc-9358-a8b4c9bbf16e",
        "storage_key": "property/6767906449166891/019d08ac-c1e7-71cc-9358-a8b4c9bbf16e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9829",
      "poi_directions_map_url": "https://maps.google.com/?cid=12242366764481047543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elmonicasw-170th-ave",
      "poi_latitude": "45.5099231",
      "poi_longitude": "-122.8515139",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-c6QOOMOlVQR9-vwnrWf5ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_5875ff73-879a-46fa-a79f-8bc45554bcb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Nike World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Bowerman Dr, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_long_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-d04e-70c3-9a91-273b8aa2d288.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-d04e-70c3-9a91-273b8aa2d288",
        "storage_key": "property/6767906449166891/019d08ac-d04e-70c3-9a91-273b8aa2d288.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://about.nike.com/pages/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=12026902182619501264&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike-world-headquarters",
      "poi_latitude": "45.5075349",
      "poi_longitude": "-122.8272752",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-671-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbaRNTcIOlVQR0NJnV9Aj6KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_87aec706-cf2c-4ff4-8ae9-7f2ecb06c41a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Intel Gordon Moore Park at Ronler Acres",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 NE Century Blvd, Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-d240-73b9-8d6a-42e728dc2540.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-d240-73b9-8d6a-42e728dc2540",
        "storage_key": "property/6767906449166891/019d08ac-d240-73b9-8d6a-42e728dc2540.webp",
        "width": 1280,
        "height": 997
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8328745523481169069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-gordon-moore-park-at-ronler-acres",
      "poi_latitude": "45.54101319999999",
      "poi_longitude": "-122.9168708",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 408-765-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28RnPXkFlVQRrUy4D-2llXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9752466a-9f1e-4395-8a0c-b4196605aafd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Intel Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Ronler Acres 3, 2501 NE Century Blvd, Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-671a-747a-897c-618ea33c9246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-671a-747a-897c-618ea33c9246",
        "storage_key": "property/6767906449166891/019d08ad-671a-747a-897c-618ea33c9246.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14911434154982632404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-corporation",
      "poi_latitude": "45.5452239",
      "poi_longitude": "-122.9126512",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 607-761-6281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGS6CxHgFlVQR1OtdG1wO8M4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_40788fb0-3ea3-455c-acbf-48a3abde87ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Intel RA4 Main Lobby",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3100 NE Stucki Ave, Hillsboro, OR 97124, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-6954-746b-ba4e-342553f70e2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-6954-746b-ba4e-342553f70e2f",
        "storage_key": "property/6767906449166891/019d08ad-6954-746b-ba4e-342553f70e2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3713851987025361628&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-ra4-main-lobby",
      "poi_latitude": "45.5417436",
      "poi_longitude": "-122.8726584",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXTybsQFlVQR3HoGk7RAijM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_84de63ac-6108-4ac0-8e1b-3c97a407e5c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "poi_name": "Intel Aloha Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3585 SW 198th Ave, Aloha, OR 97007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ad-6a44-739c-8cc1-4fd9da40de03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ad-6a44-739c-8cc1-4fd9da40de03",
        "storage_key": "property/6767906449166891/019d08ad-6a44-739c-8cc1-4fd9da40de03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14108862077939276750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intel-aloha-campus",
      "poi_latitude": "45.4932457",
      "poi_longitude": "-122.8830336",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 971-215-0582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-e1df-76a9-8aa8-64f5d88c712e",
        "storage_key": "property/6767906449166891/019d08ac-e1df-76a9-8aa8-64f5d88c712e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJle0AW0gOlVQRztuM1E6_zMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_9b1b07d8-0c7d-481d-b1bb-9e2d5212ddcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_b65a0232-fb85-4ce3-a49e-a6fcd99ff0f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_92498051-f617-42ac-8a53-384a0115b1d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_3a47933c-1b2e-4acd-9854-66f6bb3b3b8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_b7242747-5122-4d95-95b6-0a163fa71002",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_9bed0c24-d59a-4cad-ac0f-b13bcdce04e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_d0f44b4c-66a9-4bb6-84cd-cb5eea04e5bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_b75ddd39-86e7-4933-bb15-4c7d432aee07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "rating": "5.0",
      "name": "Ana Negrete",
      "text": "A little pricey, but the apartment is sparkling clean upon move-in. Maintanence is amazingly responsive and takes care of any issue promptly. Enough parking space. Lived there for 4 years and enjoyed my stay.",
      "date": "2024-09-12",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_fe9481cb-6e4d-427e-aa61-29598f91f51c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b6b-e77c-72c9-8580-34071ae1a6d5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b6b-e77c-72c9-8580-34071ae1a6d5",
        "storage_key": "property/6767906449166891/019d2b6b-e77c-72c9-8580-34071ae1a6d5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Elmonica Court Apartments - 1 Bedroom 1 Bath 720 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eQXAPiwsPww"
    },
    {
      "id": "custom_a4e4def0-a61e-45d2-b3c6-7a823b716e63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b6c-008e-700e-b0e9-04617a828d0e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b6c-008e-700e-b0e9-04617a828d0e",
        "storage_key": "property/6767906449166891/019d2b6c-008e-700e-b0e9-04617a828d0e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Elmonica Court Apartments - 2 Bedroom 1.3 Bath 900 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nKm8mpnqkPQ"
    },
    {
      "id": "custom_6d4ff597-06fb-40db-b754-d88552b16615",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b6c-1ac0-73fd-a365-b638cdd0e6af.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b6c-1ac0-73fd-a365-b638cdd0e6af",
        "storage_key": "property/6767906449166891/019d2b6c-1ac0-73fd-a365-b638cdd0e6af.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Elmonica Court Apartments - 3 Bedroom 2 Bath 1110 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9btmiLp8DTr"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db1a8-1669-729b-b5af-529c6299d6a4",
      "lead_source": "LANDING_PAGE",
      "name": "Elmonica Court Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "elmonica-court-in-unit-washer-dryer",
      "search_query": "apartments with in-unit washer and dryer Beaverton OR",
      "category": "Amenity",
      "h1_title": "In-Unit Washer & Dryer Apartments",
      "h2_subtitle": "Discover the ease of living in Beaverton OR with apartments at Elmonica Court. Enjoy the comfort and convenience of an in-unit washer and dryer.",
      "page_copy": "Experience the ultimate convenience at Elmonica Court in Beaverton, OR. Our apartments, nestled within the vibrant neighborhood of Five Oaks, boast essential amenities like in-unit washer and dryer, adding a touch of modernity and ease to your daily routine. Imagine returning home after a busy day knowing you have the freedom to do laundry in the privacy of your own space, without leaving the comfort of our beautifully designed units.\n\nLocated just across the street from the Elmonica MAX Station, our community simplifies daily commutes. Additionally, residents relish nature's beauty with proximity to THPRD nature trails. Embrace both convenience and tranquility at Elmonica Court, where every aspect of community living is crafted with you in mind. Discover why these Beaverton, OR apartments are a perfect match for those seeking both comfort and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - In-Unit Washer & Dryer Apartments",
      "seo_description": "Find apartments with in-unit washer and dryer at Elmonica Court in Beaverton OR. Enjoy convenience and comfort with Elmonica Court's amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "washington-county-pool-view-apartments",
      "search_query": "pool view apartments in Washington County",
      "category": "Amenity",
      "h1_title": "Pool View Apartments in Washington County",
      "h2_subtitle": "Enjoy stunning pool views at Elmonica Court in Beaverton. Discover why our Washington County apartments offer a refreshing lifestyle.",
      "page_copy": "Immerse yourself in the scenic tranquility at Elmonica Court, where pool view apartments redefine living in Washington County. Located in the charming city of Beaverton, OR, our community is designed to offer residents a harmonious blend of luxury and nature. Wake up to the soothing sights of our sparkling pool from the comfort of your apartment, providing a daily escape into relaxation.\n\nSituated within the flourishing neighborhood of Five Oaks, Elmonica Court is just steps from the Elmonica MAX Station and THPRD nature trails. These unique features enhance the appeal of our Washington County apartments, offering both convenient urban access and natural retreats. Step into a vibrant community that embraces leisure and comfort, making day-to-day living a breezy affair.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool View Apartments - Elmonica Court",
      "seo_description": "Discover pool view apartments at Elmonica Court in Washington County. Enjoy luxury living in Beaverton, OR with stunning poolside vistas.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-elmonica-max",
      "search_query": "smoke free apartments near Elmonica Max Station",
      "category": "Amenity",
      "h1_title": "Smoke Free Apartments by Elmonica MAX",
      "h2_subtitle": "Find a breath of fresh air in Beaverton, OR, with smoke-free living. Elmonica Court offers serene apartments near the Elmonica MAX Station.",
      "page_copy": "Embrace a healthier lifestyle at Elmonica Court, featuring smoke free apartments just across from the Elmonica MAX Station in Beaverton, OR. Our commitment to maintaining a clean and fresh environment ensures residents can enjoy their homes and community spaces without the concern of smoke. It's the perfect setting for families and individuals who value air quality and a clean atmosphere.\n\nLocated in the heart of the Five Oaks neighborhood, Elmonica Court also offers a host of amenities including convenient access to public transportation and THPRD nature trails, making it an ideal spot for those seeking both tranquility and connectivity. Live a life filled with clean air and convenience at Elmonica Court, where smoke-free living enhances the quality of your every day.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - Smoke Free Apartments by MAX",
      "seo_description": "Enjoy smoke-free living at Elmonica Court, located by the Elmonica MAX Station in Beaverton, OR. Experience fresh air living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "five-oaks-energy-efficient-apartments",
      "search_query": "energy efficient apartments Five Oaks neighborhood",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments in Five Oaks",
      "h2_subtitle": "Discover eco-friendly living in Beaverton's Five Oaks. Elmonica Court offers energy efficient apartments designed for modern living.",
      "page_copy": "Elmonica Court provides energy efficient apartments in the esteemed Five Oaks neighborhood of Beaverton, OR. Our community values sustainability and has incorporated numerous energy-saving features into the design of our homes. This dedication not only lowers utility bills but also minimizes our environmental footprint, catering to eco-conscious renters who desire sustainable living in a thriving urban setting.\n\nLocated adjacent to the Elmonica MAX Station, our apartments facilitate easy travel while still offering the tranquility of nearby THPRD nature trails. Residents enjoy the blend of modern amenities with eco-friendly designs, ensuring a lifestyle that supports both convenience and environmental responsibility. Make Elmonica Court your home and join a community committed to energy efficiency and sustainable living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Eco-Friendly Apartments in Five Oaks, Beaverton",
      "seo_description": "Experience energy efficient apartment living at Elmonica Court in the Five Oaks neighborhood of Beaverton, OR. Eco-friendly features await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "beaverton-apartments-covered-parking-97006",
      "search_query": "apartments with covered parking 97006",
      "category": "Amenity",
      "h1_title": "Apartments with Covered Parking in 97006",
      "h2_subtitle": "Elmonica Court in Beaverton, OR, offers convenient apartments with covered parking. Enjoy ease and protection in the 97006 area.",
      "page_copy": "Situated in the heart of Beaverton, OR, Elmonica Court boasts apartments with covered parking options in the sought-after 97006 area. Residents can rest easy knowing their vehicles are shielded from the elements year-round, offering enhanced protection and peace of mind. This added convenience complements the array of modern amenities available, allowing residents to embrace a truly comfortable living experience.\n\nBeyond the secure parking, Elmonica Court features a stellar location across the street from the Elmonica MAX Station, providing unparalleled access to public transit. Nearby THPRD nature trails offer abundant opportunities for outdoor recreation, making Elmonica Court a perfect home for both convenience and adventure. Discover our community's emphasis on ease and accessibility through thoughtfully designed apartment living with covered parking.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - Covered Parking in Beaverton",
      "seo_description": "Find apartments with covered parking at Elmonica Court, located in the 97006 area of Beaverton, OR. Enjoy convenience and protection today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "spacious-1-bedroom-apartments-beaverton",
      "search_query": "1 bedroom apartments in Beaverton OR",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Beaverton, OR",
      "h2_subtitle": "Explore Elmonica Court's spacious 1 bedroom apartments in Beaverton, OR. Perfect for modern living in Washington County.",
      "page_copy": "Discover the ideal blend of comfort and convenience at Elmonica Court, where our 1 bedroom apartments in Beaverton, OR, offer a welcoming and spacious retreat. Thoughtfully designed with modern living in mind, these residences provide a perfect balance of style and functionality, featuring floor plans that maximize space and natural light.\n\nElmonica Court's premier location provides easy access to the Elmonica MAX Station and nearby THPRD nature trails, making it a desirable choice for those who value mobility and outdoor adventures. Our community amenities, including garages and options for pool views, further enhance the living experience, ensuring residents enjoy an enriched lifestyle. Choose Elmonica Court for an exceptional 1 bedroom apartment experience in vibrant Beaverton.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - 1 Bedroom Apartments in Beaverton",
      "seo_description": "Discover spacious 1 bedroom apartments at Elmonica Court in Beaverton, OR. Enjoy modern living with easy access to local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "three-bedroom-floor-plans-five-oaks",
      "search_query": "3 bedroom floor plans Five Oaks Beaverton",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Floor Plans in Five Oaks",
      "h2_subtitle": "Discover spacious 3 bedroom floor plans at Elmonica Court. Located in the Five Oaks neighborhood of Beaverton, these homes cater to family living.",
      "page_copy": "Experience the ultimate in spacious living with Elmonica Court’s 3 bedroom floor plans in the Five Oaks neighborhood of Beaverton, OR. Our airy, well-designed apartments offer plenty of room for families or those needing extra space. Each residence is crafted with comfort in mind, featuring modern amenities that promise a delightful living experience.\n\nNestled near the Elmonica MAX Station, our community ensures swift transit access while remaining close to the beautiful THPRD nature trails, ideal for outdoor enthusiasts. Residents can enjoy the best of urban conveniences and serene nature escapes, making Elmonica Court the perfect place to call home. Explore our 3 bedroom layouts today, where comfort meets convenience in vibrant Five Oaks.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - 3 Bedroom Floor Plans in Beaverton",
      "seo_description": "Explore spacious 3 bedroom floor plans at Elmonica Court in Five Oaks, Beaverton. Ideal for families seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "two-bedroom-rentals-near-97006",
      "search_query": "2 bedroom rentals near 97006",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Rentals Near 97006",
      "h2_subtitle": "Elmonica Court offers stylish 2 bedroom rentals near the 97006 area. Experience the convenience and comfort of Beaverton living.",
      "page_copy": "Welcome to Elmonica Court, where you can find ideal 2 bedroom rentals near the 97006 area in Beaverton, OR. Our community is designed to provide a harmonious blend of convenience and style, with spacious apartments that are perfect for small families or roommates desiring a little extra room.\n\nLocated just steps from the Elmonica MAX Station and THPRD nature trails, Elmonica Court makes commuting and outdoor activities easy and enjoyable. Along with the practicality of garages and the choice of scenic pool views, our neighborhood offers everything you need within a close-knit community environment. Choose Elmonica Court for your next home and enjoy the accessibility and charm of Beaverton, OR.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - 2 Bedroom Rentals Near 97006",
      "seo_description": "Find perfect 2 bedroom rentals at Elmonica Court, conveniently located near the 97006 area in Beaverton, OR. Enjoy accessible and comfortable apartment living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "apartments-near-portland-community-college-rock-creek",
      "search_query": "apartments near Portland Community College Rock Creek Beaverton",
      "category": "School",
      "h1_title": "Apartments Near Portland Community College",
      "h2_subtitle": "Discover Elmonica Court apartments near Portland Community College Rock Creek in Beaverton. Ideal for students and professionals alike.",
      "page_copy": "Situated in the vibrant community of Beaverton, Elmonica Court provides perfect apartments near Portland Community College Rock Creek, offering an excellent choice for students and faculty. Our modern and comfortable living spaces are thoughtfully designed to cater to the unique needs of academics, ensuring a tranquil environment conducive to study and relaxation.\n\nResiding at Elmonica Court means enjoying a convenient lifestyle with seamless access to the Elmonica MAX Station and nearby THPRD nature trails. These well-rounded amenities make our community a popular choice for those who appreciate both urban and natural surroundings. Whether you're attending classes or seeking a quiet neighborhood, Elmonica Court is your gateway to comfortable and connected living close to Portland Community College Rock Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - Apartments Near Portland Community College",
      "seo_description": "Find the ideal living space at Elmonica Court, located near Portland Community College Rock Creek. Perfect for students and staff in Beaverton, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "apartments-near-providence-st-vincent-hospital-east-pavilion",
      "search_query": "apartments near Providence St. Vincent Hospital East Pavilion Beaverton",
      "category": "Hospital",
      "h1_title": "Apartments Near Providence St. Vincent Hospital",
      "h2_subtitle": "Elmonica Court offers convenient apartments near Providence St. Vincent Hospital East Pavilion in Beaverton, ideal for healthcare professionals.",
      "page_copy": "For those seeking comfortable apartments near Providence St. Vincent Hospital East Pavilion in Beaverton, Elmonica Court presents an excellent choice. Our thoughtfully designed units cater to the fast-paced lives of healthcare professionals, providing a peaceful haven just a short commute from your workplace.\n\nElmonica Court not only offers comfort, but also an unparalleled location near the Elmonica MAX Station, ensuring easy commuting options across the Beaverton and Portland areas. Enjoy leisurely walks on the nearby THPRD nature trails or relax with poolside views. Whether you work at the hospital or simply desire proximity to quality healthcare facilities, Elmonica Court provides the balance of accessibility and serene living in the bustling Beaverton community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - Apartments Near Providence St. Vincent",
      "seo_description": "Live near Providence St. Vincent Hospital East Pavilion with Elmonica Court. Perfect apartment options for healthcare professionals in Beaverton, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "apartments-close-to-providence-st-vincent-medical-center",
      "search_query": "apartments close to Providence St. Vincent Medical Center Five Oaks",
      "category": "Hospital",
      "h1_title": "Apartments Close to Providence St. Vincent",
      "h2_subtitle": "Find Elmonica Court apartments close to Providence St. Vincent Medical Center in Five Oaks, Beaverton. Ideal for professionals seeking convenience.",
      "page_copy": "Located in the heart of Beaverton’s Five Oaks neighborhood, Elmonica Court boasts apartments close to Providence St. Vincent Medical Center. Our community offers an ideal home base for medical professionals desiring convenient living with quick access to work.\n\nElmonica Court provides a variety of features including modern living spaces and easy access to public transport via the nearby Elmonica MAX Station. Engage with nature along THPRD's trails, or enjoy the serenity of scenic pool views right at home. With these amenities and more, Elmonica Court is perfectly positioned to offer both tranquility and convenience for those working at Providence St. Vincent Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - Close to Providence St. Vincent Medical",
      "seo_description": "Find your home at Elmonica Court, near Providence St. Vincent Medical Center in Beaverton's Five Oaks. Ideal for healthcare professionals seeking convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "apartments-near-tualatin-hills-nature-park",
      "search_query": "apartments near Tualatin Hills Nature Park Beaverton",
      "category": "Park",
      "h1_title": "Apartments Near Tualatin Hills Nature Park",
      "h2_subtitle": "Explore Elmonica Court's apartments near Tualatin Hills Nature Park in Beaverton. Perfect for nature lovers.",
      "page_copy": "Nestled conveniently in Beaverton, Elmonica Court offers ideal apartments near Tualatin Hills Nature Park for those who cherish the great outdoors. Our community provides easy access to beautiful natural surroundings while still being close to city conveniences.\n\nResidents of Elmonica Court enjoy features like online rent payments and access to THPRD nature trails, offering a seamless blend of comfort and connectivity. The Elmonica MAX Station is right across the street, making urban commutes a breeze. With scenic pool views and garage options, Elmonica Court combines the best of serene living and modern convenience for anyone who loves being close to nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - Near Tualatin Hills Nature Park",
      "seo_description": "Discover serene living at Elmonica Court, near Tualatin Hills Nature Park in Beaverton. Ideal apartments for nature enthusiasts seeking modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "elmonica-court-close-to-hidden-creek-park-west",
      "search_query": "Elmonica Court close to Hidden Creek Park West Five Oaks",
      "category": "Park",
      "h1_title": "Elmonica Court Near Hidden Creek Park West",
      "h2_subtitle": "Discover Elmonica Court's close proximity to Hidden Creek Park West in the Five Oaks neighborhood. Ideal for park enthusiasts.",
      "page_copy": "Situated in the vibrant Five Oaks neighborhood, Elmonica Court is perfectly positioned close to Hidden Creek Park West, offering nature lovers easy access to this serene outdoor attraction. Our community provides a harmonious blend of parkland beauty and city convenience, making it an ideal choice for those who appreciate being near green spaces.\n\nAt Elmonica Court, residents enjoy amenities such as online rent payments and quick access to the Elmonica MAX Station, facilitating stress-free commutes. Our adjacency to THPRD nature trails enhances the outdoor experiences right from your doorstep. Whether it's a relaxing day at the park or convenient urban living, Elmonica Court delivers the perfect setting for all your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court Near Hidden Creek Park West",
      "seo_description": "Live at Elmonica Court, close to Hidden Creek Park West in Five Oaks, Beaverton. Ideal for park enthusiasts seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "beaverton-apartments-near-cooper-mountain-nature-park",
      "search_query": "Beaverton apartments near Cooper Mountain Nature Park",
      "category": "Park",
      "h1_title": "Beaverton Apartments Near Cooper Mountain Park",
      "h2_subtitle": "Find Elmonica Court, the Beaverton apartments near Cooper Mountain Nature Park. Perfect for those seeking nature and modern comforts.",
      "page_copy": "Discover the ideal blend of nature and city living at Elmonica Court, offering Beaverton apartments near Cooper Mountain Nature Park. Our community is tailored for those who value both convenience and proximity to stunning nature vistas.\n\nWith easy access to the Elmonica MAX Station, residents enjoy seamless commutes combined with leisure activities like trails within THPRD and views of our serene pool. Elmonica Court provides a range of amenities including garages and online rent payment options. It’s the ideal setting for anyone who seeks a vibrant lifestyle with the beauty of Cooper Mountain Nature Park not far from home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Beaverton Apartments Near Cooper Mountain Park",
      "seo_description": "Explore Elmonica Court in Beaverton, close to Cooper Mountain Nature Park. Perfect for those seeking modern living and natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "apartments-near-beaverton-tc-max-station",
      "search_query": "apartments near Beaverton TC MAX Station Oregon",
      "category": "Transit",
      "h1_title": "Apartments Near Beaverton TC MAX Station",
      "h2_subtitle": "Discover Elmonica Court's proximity to Beaverton TC MAX Station in Oregon. Perfect for seamless commuting.",
      "page_copy": "Elmonica Court is strategically located for those seeking apartments near Beaverton TC MAX Station, Oregon. Our community ensures effortless accessibility to public transit, making it perfect for commuters who value convenience and efficiency.\n\nAt Elmonica Court, residents benefit from amenities such as online rent payments and a prime location across from the Elmonica MAX Station. Furthermore, enjoy the natural surroundings with adjacent THPRD nature trails. Ideal for anyone looking to combine the ease of urban transit with welcoming community features, Elmonica Court offers the perfect home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - Near Beaverton TC MAX Station",
      "seo_description": "Elmonica Court offers convenient living near Beaverton TC MAX Station, Oregon. Ideal for commuters seeking comfort and accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "rentals-close-to-quatama-station-beaverton",
      "search_query": "rentals close to Quatama station Beaverton",
      "category": "Transit",
      "h1_title": "Rentals Close to Quatama Station, Beaverton",
      "h2_subtitle": "Explore Elmonica Court's rentals near Quatama Station in Beaverton. Perfect for easy commuting and convenience.",
      "page_copy": "Elmonica Court presents an excellent option for those seeking rentals close to Quatama Station in Beaverton. Our community not only offers proximity to public transport but also provides a harmonious balance of comfort and convenience for everyday living.\n\nResidents at Elmonica Court can enjoy a range of amenities, including the ease of online rent payments and a location right across from the Elmonica MAX Station. Our community is also adjacent to THPRD nature trails, perfect for those who appreciate a touch of nature. Choose Elmonica Court for a lifestyle that blends perfect commuting options with the tranquility of natural surroundings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Quatama Station, Beaverton",
      "seo_description": "Discover Elmonica Court, offering rentals close to Quatama Station in Beaverton. Ideal for those seeking easy commuting and modern convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "apartments-near-orenco-max-five-oaks",
      "search_query": "apartments near Orenco MAX Five Oaks",
      "category": "Transit",
      "h1_title": "Apartments Near Orenco MAX, Five Oaks",
      "h2_subtitle": "Discover Elmonica Court, apartments near Orenco MAX in the Five Oaks neighborhood. Ideal for vibrant living.",
      "page_copy": "Situated in the heart of Five Oaks, Elmonica Court is the perfect choice for those seeking apartments near Orenco MAX. This community combines modern convenience with a welcoming environment, ensuring a comfortable lifestyle.\n\nResidents enjoy easy access to public transportation with the Elmonica MAX Station right across the street. Additional amenities include online rent payments, garage options, and beautiful natural surroundings with access to the THPRD nature trails. Choose Elmonica Court for close proximity to the Orenco MAX and enjoy all the benefits of life in Beaverton's lively Five Oaks neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - Near Orenco MAX, Five Oaks",
      "seo_description": "Explore Elmonica Court's comfort and convenience near Orenco MAX in Five Oaks. Ideal living in a vibrant Beaverton community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166891",
      "source": "generator",
      "page_item_url": "elmonica-court-near-elmonica-sw-170th-transit",
      "search_query": "Elmonica Court near Elmonica/SW 170th Ave transit",
      "category": "Transit",
      "h1_title": "Elmonica Court Near SW 170th Transit",
      "h2_subtitle": "Discover Elmonica Court, ideally located near Elmonica/SW 170th Ave transit station. Perfect for convenient commuting.",
      "page_copy": "Elmonica Court offers a prime location for anyone looking to stay connected with easy access to Elmonica/SW 170th Ave transit. Located in Beaverton's Five Oaks neighborhood, our community provides both the tranquility of nature and the convenience of urban transport.\n\nResidents at Elmonica Court can take advantage of being just across the street from the Elmonica MAX Station, making daily commutes a breeze. Our community embraces modern living with offerings like online rent payments, garages, and the beauty of nearby THPRD nature trails. Whether you're commuting or enjoying local amenities, Elmonica Court is an ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d2b64-f11d-7168-b8cb-6943c8c3c9b1",
        "storage_key": "property/6767906449166891/019d2b64-f11d-7168-b8cb-6943c8c3c9b1.webp",
        "width": 2048,
        "height": 956
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elmonica Court - Access to SW 170th Transit",
      "seo_description": "Live at Elmonica Court with direct access to Elmonica/SW 170th Ave transit. Enjoy convenience and comfort in the heart of Beaverton's Five Oaks.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5959"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372409955"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-N656P2X8"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-727-6797 "
    }
  ],
  "custom_qb_id": "5959",
  "custom_repli_id": "18372409955",
  "custom_google_gtm_id": "\tGTM-N656P2X8",
  "custom_ppc_tracking_phone_number": "844-727-6797 "
};

export const generatedAt = '2026-10-05T21:06:06.805Z';
